import * as React from 'react';
import {DisabledReadOnly} from './DisabledReadOnly.story';
import {Invalid} from './Invalid.story';
import {Primary} from './Primary.story';
import {Size} from './Size.story';
import {Type} from './Type.story';
import {Uncontrolled} from './Uncontrolled.story';
import {Width} from './Width.story';

const basic = {
  rendered: <Primary />,
  source: `<TextField
  label="Business name"
  placeholder="Acme Inc…"
  onChange={(e) => {
    console.log(e.target.value);
  }}
/>`,
};
const type = {
  rendered: <Type />,
  source: `<TextField label="Text" type="text" />
<TextField label="Password" type="password" />
<TextField label="Search" type="search" />
<TextField label="Number" type="number" />`,
};
const size = {
  rendered: <Size />,
  source: `<TextField label="Small" size="small" />
<TextField label="Medium" size="medium" />
<TextField label="Large" size="large" />`,
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<TextField
  onChange={(e) => {
    console.log(e);
  }}
  label="First name"
/>`,
};
const width = {
  rendered: <Width />,
  source: `<TextField label="Age" />`,
};
const invalid = {
  rendered: <Invalid />,
  source: `<TextField label="Current year" defaultValue="1892" invalid />`,
};
const disabledReadOnly = {
  rendered: <DisabledReadOnly />,
  source: `<TextField label="Disabled" defaultValue="Field is disabled" disabled />
<TextField label="Readonly" defaultValue="Field is readonly" readOnly />`,
};
export const TextFieldExamples = {
  basic,
  uncontrolled,
  disabledReadOnly,
  invalid,
  width,
  size,
  type,
};
